const PAGE_SIZE_OPTIONS = ["5", "10", "20", "30", "40", "50"];
const DEFAULT_PAGE_SIZE = parseInt(PAGE_SIZE_OPTIONS[1], 10);

export { PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE };
